import { Injectable } from "@angular/core"
import { ModalService } from "../shared-components/modal/modal.service"

import { AuthModalComponent } from "../shared-components/modals/auth-modal/auth-modal.component"
import { StudentLoginModalComponent } from "../shared-components/modals/student-login-modal/student-login-modal.component"
import { UserService } from "./user.service"

@Injectable({
    providedIn: "root",
})
export class LMModalService {
    constructor(private userService: UserService, private modalService: ModalService) {}

    public openLoginModal() {
        this.modalService.open(
            this.userService.hasStudentExperience()
                ? StudentLoginModalComponent
                : AuthModalComponent
        )
    }
}
